// ONSEN SCRIPT
$(document).ready(function(){
	// WRISTBAND REGISTER
	wristbandRegister_exit = $('#wristbandRegister').length;
	if(wristbandRegister_exit){
		$(window).scannerDetection({
			timeBeforeScanTest	:	300, // tolerate mid-scan gaps (long codes)
			onReceive	:	function(code){
				loading();
			},
			onError		:	function(code){
				unload();
			},
			onComplete	:	function(code){
				unload();
				$.ajax({
					type	:	"POST",
					url		:	"ajax.php",
					data	:	{command: "wristband_register", code: code},
					success	:	function(data){
						$('#wristbandRegister').html(data);
						window.setTimeout('location.reload()', 500);
					}
				});
			}
		});
	}

	// WRISTBAND UPDATE
	wristbandUpdate_exit = $('#wristbandUpdate').length;
	if(wristbandUpdate_exit){
		$(window).scannerDetection({
			timeBeforeScanTest	:	300, // tolerate mid-scan gaps (long codes)
			onReceive	:	function(code){
				loading();
			},
			onError		:	function(code){
				unload();
			},
			onComplete	:	function(code){
				unload();
				$.ajax({
					type	:	"POST",
					url		:	"ajax.php",
					data	:	{command: "wristband_update", code: code},
					success	:	function(data){
						$('#wristbandUpdate').html(data);
						window.setTimeout('location.reload()', 500);
					}
				});
			}
		});
	}

	$('button.button_free_RFID').click(function(){
		if(confirm("ต้องการปลดล็อค RFID และ กุญแจ นี้มั้ย?")){
			RFID_id = $(this).attr('id');
			keychain_id = $(this).attr('keychain_id');
			$.ajax({
				type	:	"POST",
				url		:	"ajax.php",
				data	:	{command: "freeRFID", RFID_id: RFID_id, keychain_id: keychain_id},
				success	:	function(data){
					location.reload();
				}
			});
		}
	});

	$('button.button_view_onsen_detail').click(function(){
		onsen_order_id = $(this).attr('onsen_order_id');
		RFID_id = $(this).attr('RFID_id');
		order_id = $(this).attr('order_id');
		this_button = $(this);
		$.ajax({
			type 		: "POST",
			url  		: "ajax.php",
			data 		: {command: "viewOnsenDetail", RFID_id: RFID_id, order_id: order_id},
			beforeSend	:	function(){
				loading();
			},
			success		:	function(data){
				unload();
				this_button.parent().parent().parent().find('.RFID_detail_'+RFID_id).html(data);
			}
		});
	});
});

// FUNCTION
function doRFIDRegister(code){
	onsen_page = $('input[name=onsen_page]').val();
	$.ajax({
		type	:	"POST",
		url		:	"ajax.php",
		data	:	{command: "registerRFID", RFID_code: code, onsen_page: onsen_page},
		dataType:	"json",
		success	:	function(data){
			unload();
			$('#registerRFID').html(data.show);

			// DO REMOVE BUTTON
			loadRFIDRegister();
		}
	});
}
function loadRFIDRegister(){
	// DO REMOVE BUTTON
	$('.remove_RFID_register').click(function(){
		RFID_code = $(this).attr('RFID_code');
		$.ajax({
			type	:	"POST",
			url		:	"ajax.php",
			data	:	{command: "removeRFIDregister", RFID_code: RFID_code},
			dataType:	"json",
			success	:	function(data){
				$('#registerRFID').html(data.show);
				loadRFIDRegister();
			}
		});
	});
}
function loadKeychainRegister(){
	// DO REMOVE BUTTON
	$('.remove_keychain_register').click(function(){
		keychain_code = $(this).attr('keychain_code');
		$.ajax({
			type	:	"POST",
			url		:	"ajax.php",
			data	:	{command: "removeKeychainRegister", keychain_code: keychain_code},
			dataType:	"json",
			success	:	function(data){
				$('#registerKeychain').html(data.show);
				loadKeychainRegister();
			}
		});
	});
}

function loadRFID(code){
	console.log('loadRFID : '+code);
	onsen_page = $('input[name=onsen_page]').val();
	
	$.ajax({
		type 		:	"POST",
		url  		:	"ajax.php",
		dataType	:	"json",
		data 		:	{command: "scan_RFID", code: code, onsen_page: onsen_page},
		beforeSend	:	function(){
			loading();
		},
		success		:	function(data){
			// console.log(data);
			unload();

			if(data.status){
				switch(data.code_type){
					case 'RFID':
					case 'product':
						$('.dropzone').html(data.show);

						realtimeCalculation();
						$('#scanRFID .live_cal').change(function(){
							realtimeCalculation();
						});

						// SHOW BAG DETAIL
						$('button[name=return_bag_button]').click(function(){
							$(this).fadeOut().remove();
							$('.bag_detail').removeClass('hide').fadeIn(300);
						});

						// DELETE BAG
						$('button[name=remove_bag_button]').click(function(){
							if(confirm("ต้องการลบกระเป๋านี้ออก?")){
								onsen_order_id = $(this).attr('onsen_order_id');
								$.ajax({
									type	:	"POST",
									url		:	"ajax.php",
									data	:	{command: "delete_bag", onsen_order_id: onsen_order_id},
									success	:	function(){
										loadRFID(code);
									}
								});
							}
						});

						// CANCEL RETURN FULL BAG
						$('button[name=bag_return_cancel_button]').click(function(){
							if(confirm("ยกเลิกการคืน?")){
								onsen_order_id = $(this).attr('onsen_order_id');
								$.ajax({
									type	:	"POST",
									url		:	"ajax.php",
									data	:	{command: "cancelReturnBag", onsen_order_id: onsen_order_id},
									success	:	function(){
										// $('button[name=return_full_bag_button], .lost_bag_button').remove();
										loadRFID(code);
									}
								});
							}
						});

						// RETURN FULL BAG
						$('button[name=return_full_bag_button]').click(function(){
							if(confirm("ตรวจของแล้ว? ยืนยันการคืนกระเป๋านะ?")){
								onsen_order_id = $(this).attr('onsen_order_id');
								$.ajax({
									type	:	"POST",
									url		:	"ajax.php",
									data	:	{command: "returnFullBag", onsen_order_id: onsen_order_id},
									success	:	function(){
										$('button[name=return_full_bag_button], .lost_bag_button').remove();
										loadRFID(code);
									}
								});
							}
						});

						// LOST BAG
						$('.lost_bag_button').click(function(){
							this_button = $(this);
							onsen_order_id = $(this).attr('onsen_order_id');
							onsen_order_detail_id = $(this).attr('onsen_order_detail_id');
							is_free = $(this).attr('is_free');
							lost_product_id = $(this).val();
							$.ajax({
								type		:	"POST",
								url			:	"ajax.php",
								data		:	{command: "submitLostBag", onsen_order_id: onsen_order_id, onsen_order_detail_id: onsen_order_detail_id, lost_product_id: lost_product_id, is_free: is_free},
								success		:	function(){
									this_button.parent().addClass('lost');
									this_button.prop('disabled', true);
									loadRFID(code);
								}
							});
						});

						// DELETE ONSEN PRODUCT
						$('.delete_onsen_product').click(function(){
							if(remark = prompt("ป้อนเหตุผลที่ลบสินค้านี้?")){
								if(remark.length <= 5){
									alert("พิมพ์เหตุผลยาวๆ หน่อย");
								}else{
									onsen_order_detail_id = $(this).attr('onsen_order_detail_id');
									$.ajax({
										type	:	"POST",
										data	:	{command: "deleteOnsenProduct", onsen_order_detail_id: onsen_order_detail_id, remark: remark},
										url		:	"ajax.php",
										success	:	function(){
											// RELOAD RFID
											loadRFID(data.RFID_code);
										}
									});
								}
							}
						});

						// SET PAYMENT
						$('#payment_type').hide();
						$('#payment_type .payment_type').change(function(){
							loading();
							this_obj = $(this);
							payment_detail_box = $(this).parent().parent().parent().parent().parent().find('.payment_detail_box');
							payment_type_id = $(this).val();
							index_id = $(this).attr('index_id');
							$.ajax({
								type : "POST",
								url : "ajax.php",
								dataType : "json",
								data : {command: "getPaymentSub", payment_type_id: payment_type_id, index_id: index_id},
								success : function(data){
									console.log(data+' getPaymentSub');
									unload();
									parent_box = $('.payment_type').not(this_obj).parent().parent().parent().parent().parent();
									amount = parent_box.find('.payment_amount_input');
									disabled_detail_box = parent_box.find('.payment_detail_box');
									
									if(data.foc){
										$('.payment_type').not(this_obj).val('').prop('disabled', true);
										disabled_detail_box.html('');
										amount.val('').prop('disabled', true);
										$('input[name=is_foc]').val(true);
									}else{
										$('.payment_type').prop('disabled', false);
										amount.prop('disabled', false);
										$('input[name=is_foc]').val(false);
									}
									realtimeCalculation();
									payment_detail_box.html(data.show);

									// EDC
									setEDC();
									setCreditCardNext();
								}
							});
						});
						$('#RFID button[name=paynow_button]').click(function(){
							$('#scanRFID #payment_type').fadeIn(500, function(){
								setPaymentPage();
								realtimeCalculation();
								getCashierMemberLogin();
							});
						});
						$('#scanRFID .submit_payment').click(function(){
							console.log('scanRFID.submit_payment');
							getdata = $('#scanRFID #cashier_form').serialize();
							
							payment_button = $(this);
							payment_button.prop('disabled', true);
							$.ajax({
								type 		:	"POST",
								data 		:	{"command" : "checkall", "data" : getdata, "skip" : "product", "zero_paid" : true},
								url  		:	"ajax.php",
								dataType	:	"json",
								error		:	function(){
									alert("There is something wrong with the system, please try again.");
									payment_button.prop('disabled', false);
									return false;
								},
								success		:	function(data){
									// console.log(data);
									payment_button.prop('disabled', false);
									if(data.pass){
										if(requireCheck()){
											if(confirm("Pay now?")){
												$('#scanRFID #cashier_form').submit();
												return true;
											}else{
												return false;
											}
										}else{
											return false;
										}
									}else{
										alert(data.message);
										return false;
									}
								}
							});
							return false;
						});

						// PRINT COUPON
						$('.leave_onsen_button').click(function(){
							if(confirm("จะกลับบ้านแล้วใช่มั้ย?")){
								return true;
							}else{
								return false;
							}
						});
						break;
					case 'creditcard':
						current_payment_index = $('.sub_group').length;
						next_payment_index = current_payment_index + 1;
						
						$.ajax({
							url		:	"ajax.php",
							data	:	{command: "qrcode_payment", code: code, index: next_payment_index, mode: "product"},
							dataType:	"json",
							type	:	"POST",
							success	:	function(data){
								$('#special-payment').append(data.show);
								setEDC();
								setLiveCal();
								doCloseBox();
							}
						});
						$('#payment_type').show();
						break;
				}
				
			}
		}
	});
}
function doKeychainRegister(code){
	onsen_page = $('input[name=onsen_page]').val();
	$.ajax({
		type	:	"POST",
		url		:	"ajax.php",
		data	:	{command: "registerKeychain", keychain_code: code, code: code, onsen_page: onsen_page},
		dataType:	"json",
		success	:	function(data){
			unload();
			$('#registerKeychain').html(data.show);

			// DO REMOVE BUTTON
			loadKeychainRegister();
		}
	});
}